"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.useSelectState_controlled = useSelectState_controlled;
exports["default"] = exports.getValIndex = exports.normalizeSelectValue = exports.originalValue = exports.normalizeSelectOptions = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectSpread"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _react = require("react");

function filterProps(props) {
  var options = props.options,
      value = props.value,
      defaultValue = props.defaultValue,
      onChange = props.onChange,
      allowEmpty = props.allowEmpty,
      restProps = (0, _objectWithoutProperties2["default"])(props, ["options", "value", "defaultValue", "onChange", "allowEmpty"]);
  return restProps;
}

var normalizeSelectOptions = function normalizeSelectOptions(options) {
  return options.map(function (option) {
    if (typeof option === "object") {
      if (option.id === undefined || option.id === null) {
        throw new Error("[useSelectState] options must have id, this option doesn't: ".concat(option));
      }

      if (typeof option.__originalOption !== "undefined") {
        // you can't normalize already normalized value
        return option;
      }

      var label = option.label;
      var id = option.id.toString();

      if (!label) {
        label = option.id.toString();
      }

      return (0, _objectSpread2["default"])({}, option, {
        id: id,
        label: label,
        __originalOption: option
      });
    }

    if (option === null || option === undefined) {
      throw new Error("[useSelectState] options can't be null or undefined");
    } // throw new Error("options must be objects with ID!!!");


    return {
      id: option.toString(),
      label: option.toString(),
      __originalOption: option
    };
  });
};

exports.normalizeSelectOptions = normalizeSelectOptions;

var originalValue = function originalValue(val) {
  return val === null ? null : typeof val.__originalOption !== "undefined" ? val.__originalOption : val;
};

exports.originalValue = originalValue;

var normalizeSelectValue = function normalizeSelectValue(options, val, allowEmpty) {
  options = normalizeSelectOptions(options);
  var valueId = val === undefined || val === null ? val : typeof val === "object" ? val.id.toString() : val.toString();
  var valueObject = options.find(function (o) {
    return o.id === valueId;
  });
  val = valueObject || (allowEmpty ? null : options[0]);
  return val;
};

exports.normalizeSelectValue = normalizeSelectValue;

var getValIndex = function getValIndex(options, val) {
  if (val === null) {
    return null;
  }

  var index = options.findIndex(function (x) {
    return x.id === val.id;
  });

  if (index === -1) {
    return null;
  }

  return index;
};

exports.getValIndex = getValIndex;

function useSelectState(props) {
  var options = props.options,
      value = props.value,
      defaultValue = props.defaultValue,
      _onChange = props.onChange,
      _props$allowEmpty = props.allowEmpty,
      allowEmpty = _props$allowEmpty === void 0 ? true : _props$allowEmpty; // UNCONTROLLED ONLY IF: value === "undefined"

  var isControlled = typeof value !== "undefined";
  var normalizedValue = normalizeSelectValue(options, defaultValue, allowEmpty);

  var _useState = (0, _react.useState)(normalizedValue && normalizedValue.disabled ? null : normalizedValue),
      internalValue = _useState[0],
      setInternalValue = _useState[1];

  var currentValue = isControlled ? value : internalValue;
  return useSelectState_controlled((0, _objectSpread2["default"])({}, props, {
    value: currentValue,
    onChange: function onChange(newVal, index) {
      if (!isControlled) {
        setInternalValue(newVal);
      }

      if (_onChange) {
        _onChange(newVal, index);
      }
    }
  }));
}

function useSelectState_controlled(props) {
  var options = props.options,
      value = props.value,
      onChange = props.onChange,
      _props$allowEmpty2 = props.allowEmpty,
      allowEmpty = _props$allowEmpty2 === void 0 ? true : _props$allowEmpty2;
  options = normalizeSelectOptions(options); // Let's see if value or defaultValue is one from the options list or not

  var currentValue = normalizeSelectValue(options, value, allowEmpty);
  currentValue = currentValue && currentValue.disabled ? null : currentValue;

  var setValue = function setValue(newVal) {
    newVal = normalizeSelectValue(options, newVal, allowEmpty);

    if (newVal === null && currentValue === null) {
      return;
    }

    if (newVal && currentValue && newVal.id === currentValue.id) {
      return;
    }

    if (newVal && newVal.disabled) {
      return;
    }

    if (onChange) {
      onChange(originalValue(newVal), getValIndex(options, newVal));
    }
  };

  var isSelected = function isSelected(val) {
    return !!(val && currentValue && (currentValue.id === val || currentValue.id === val.id));
  };

  return {
    value: originalValue(currentValue),
    valueObject: currentValue,
    empty: currentValue === null,
    selectedIndex: getValIndex(options, currentValue),
    options: options,
    reset: function reset() {
      setValue(null);
    },
    setValue: setValue,
    isSelected: isSelected,
    selectValue: function selectValue(val) {
      setValue(val);
    },
    unselectValue: function unselectValue(val) {
      if (isSelected(val)) {
        setValue(null);
      }
    }
  };
}

useSelectState.filterProps = filterProps;
var _default = useSelectState;
exports["default"] = _default;